'use client';

import React from 'react';
import { MdClose } from 'react-icons/md';

import styles from './Modal.module.css';

type Props = {
  isOpen: boolean;
  onClose: () => void;
  title?: string;
  children: React.ReactNode;
  size?: 'sm' | 'md' | 'lg' | 'full';
  showBackButton?: boolean;
  onBack?: () => void;
};

const Modal: React.FC<Props> = ({
  isOpen,
  onClose,
  title,
  children,
  size = 'md',
  showBackButton,
  onBack,
}) => {
  if (!isOpen) return null;

  return (
    <div className={ styles.overlay } onClick={ onClose }>
      <div
        className={ `${ styles.modal } ${ styles[size] }` }
        onClick={ (e) => e.stopPropagation() }
      >
        <div className={ styles.header }>
          { showBackButton && onBack && (
            <button className={ styles.backButton } onClick={ onBack }>
              ←
            </button>
          ) }
          { title && <h2 className={ styles.title }>{ title }</h2> }
          <button className={ styles.closeButton } onClick={ onClose }>
            <MdClose size={ 24 }/>
          </button>
        </div>
        <div className={ styles.content }>
          { children }
        </div>
      </div>
    </div>
  );
};

export default Modal;
